module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-1-3f7d5f63686b4e59e5dbc05600a14fee.jpg";